// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['analise_resultado']


const DEFAULT_URL = '/analise-resultado';

const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Análise de Resultado',
    to: 'analiseResultado'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'analiseResultado',
    component: () => import('@/views/AnaliseResultados/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Análise de Resultado',
      breadcrumb: breadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'AnaliseResultadoNovo',
    component: () => import('@/views/AnaliseResultados/FormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Nova Análise de Resultado',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Nova Análise de Resultado',
          to: 'AnaliseResultadoNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'AnaliseResultadoEdit',
    component: () => import('@/views/AnaliseResultados/FormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...breadCrumb,
        {
          label: 'Detalhes',
          to: 'AnaliseResultadoEdit'
        }
      ]
    }
  }
]
